/** @return {number} - get info of wizard */
const getStoreId = state => {
  return state.storeId;
};
/** @return {string} - get info of wizard */
const getStoreUrlPrefix = state => {
  return state.storeUrlPrefix;
}

/** @return {object} - get store view infos*/
const getStoreViewsInfos = state => {
  return state.storeViews;
}

/** @return {object} - get current store view infos*/
const getCurrentStoreViewsInfos = state => {
  return state.currentStoreView;
}

export default {
  getStoreId,
  getStoreUrlPrefix,
  getStoreViewsInfos,
  getCurrentStoreViewsInfos
};
